// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Styles globaux */
.stock-management {
    font-family: 'Arial', sans-serif;
    padding: 20px;
    max-width: 1200px;
    margin: 0 auto;
    background-color: #f7f7f7;
    border-radius: 10px;
    box-shadow: 0 0 10px rgba(0,0,0,0.1);
}

h1 {
    font-size: 2em;
    color: #333;
    border-bottom: 2px solid #333;
    padding-bottom: 10px;
    margin-bottom: 20px;
}

h2 {
    font-size: 1.5em;
    color: #555;
    margin-top: 30px;
}

.section {
    margin-bottom: 30px;
}

/* Styles pour les tables */
table {
    width: 100%;
    border-collapse: collapse;
}

table, th, td {
    border: 1px solid #ccc;
}

th, td {
    padding: 8px 12px;
    text-align: left;
}

th {
    background-color: #eee;
}

tbody tr:hover {
    background-color: #f0f0f0;
}

/* Styles pour les formulaires */
input, select {
    padding: 8px;
    margin: 5px 0;
    border: 1px solid #ccc;
    border-radius: 5px;
    width: 100%;
}

button {
    padding: 10px 15px;
    background-color: #007BFF;
    color: #fff;
    border: none;
    border-radius: 5px;
    cursor: pointer;
    margin-top: 10px;
}

button:hover {
    background-color: #0056b3;
}

/* Styles pour la recherche */
ul {
    list-style-type: none;
    padding: 0;
}

ul li {
    padding: 8px;
    border: 1px solid #ccc;
    border-radius: 5px;
    margin-top: 5px;
    cursor: pointer;
    transition: background-color 0.2s;
}

ul li:hover {
    background-color: #f0f0f0;
}



.section-title {
    padding: 10px;
    background-color: #e7e7e7;
    border-radius: 5px 5px 0 0;
    font-weight: bold;
    color: #555;
}

.section-content {
    padding: 20px;
    border: 1px solid #e7e7e7;
    border-top: none;
    border-radius: 0 0 5px 5px;
    background-color: #ffffff;
    margin-bottom: 20px;
}`, "",{"version":3,"sources":["webpack://./src/components/gestion_stocks_mug/StockManagement.css"],"names":[],"mappings":"AAAA,mBAAmB;AACnB;IACI,gCAAgC;IAChC,aAAa;IACb,iBAAiB;IACjB,cAAc;IACd,yBAAyB;IACzB,mBAAmB;IACnB,oCAAoC;AACxC;;AAEA;IACI,cAAc;IACd,WAAW;IACX,6BAA6B;IAC7B,oBAAoB;IACpB,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;IAChB,WAAW;IACX,gBAAgB;AACpB;;AAEA;IACI,mBAAmB;AACvB;;AAEA,2BAA2B;AAC3B;IACI,WAAW;IACX,yBAAyB;AAC7B;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,iBAAiB;IACjB,gBAAgB;AACpB;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA,gCAAgC;AAChC;IACI,YAAY;IACZ,aAAa;IACb,sBAAsB;IACtB,kBAAkB;IAClB,WAAW;AACf;;AAEA;IACI,kBAAkB;IAClB,yBAAyB;IACzB,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA,6BAA6B;AAC7B;IACI,qBAAqB;IACrB,UAAU;AACd;;AAEA;IACI,YAAY;IACZ,sBAAsB;IACtB,kBAAkB;IAClB,eAAe;IACf,eAAe;IACf,iCAAiC;AACrC;;AAEA;IACI,yBAAyB;AAC7B;;;;AAIA;IACI,aAAa;IACb,yBAAyB;IACzB,0BAA0B;IAC1B,iBAAiB;IACjB,WAAW;AACf;;AAEA;IACI,aAAa;IACb,yBAAyB;IACzB,gBAAgB;IAChB,0BAA0B;IAC1B,yBAAyB;IACzB,mBAAmB;AACvB","sourcesContent":["/* Styles globaux */\r\n.stock-management {\r\n    font-family: 'Arial', sans-serif;\r\n    padding: 20px;\r\n    max-width: 1200px;\r\n    margin: 0 auto;\r\n    background-color: #f7f7f7;\r\n    border-radius: 10px;\r\n    box-shadow: 0 0 10px rgba(0,0,0,0.1);\r\n}\r\n\r\nh1 {\r\n    font-size: 2em;\r\n    color: #333;\r\n    border-bottom: 2px solid #333;\r\n    padding-bottom: 10px;\r\n    margin-bottom: 20px;\r\n}\r\n\r\nh2 {\r\n    font-size: 1.5em;\r\n    color: #555;\r\n    margin-top: 30px;\r\n}\r\n\r\n.section {\r\n    margin-bottom: 30px;\r\n}\r\n\r\n/* Styles pour les tables */\r\ntable {\r\n    width: 100%;\r\n    border-collapse: collapse;\r\n}\r\n\r\ntable, th, td {\r\n    border: 1px solid #ccc;\r\n}\r\n\r\nth, td {\r\n    padding: 8px 12px;\r\n    text-align: left;\r\n}\r\n\r\nth {\r\n    background-color: #eee;\r\n}\r\n\r\ntbody tr:hover {\r\n    background-color: #f0f0f0;\r\n}\r\n\r\n/* Styles pour les formulaires */\r\ninput, select {\r\n    padding: 8px;\r\n    margin: 5px 0;\r\n    border: 1px solid #ccc;\r\n    border-radius: 5px;\r\n    width: 100%;\r\n}\r\n\r\nbutton {\r\n    padding: 10px 15px;\r\n    background-color: #007BFF;\r\n    color: #fff;\r\n    border: none;\r\n    border-radius: 5px;\r\n    cursor: pointer;\r\n    margin-top: 10px;\r\n}\r\n\r\nbutton:hover {\r\n    background-color: #0056b3;\r\n}\r\n\r\n/* Styles pour la recherche */\r\nul {\r\n    list-style-type: none;\r\n    padding: 0;\r\n}\r\n\r\nul li {\r\n    padding: 8px;\r\n    border: 1px solid #ccc;\r\n    border-radius: 5px;\r\n    margin-top: 5px;\r\n    cursor: pointer;\r\n    transition: background-color 0.2s;\r\n}\r\n\r\nul li:hover {\r\n    background-color: #f0f0f0;\r\n}\r\n\r\n\r\n\r\n.section-title {\r\n    padding: 10px;\r\n    background-color: #e7e7e7;\r\n    border-radius: 5px 5px 0 0;\r\n    font-weight: bold;\r\n    color: #555;\r\n}\r\n\r\n.section-content {\r\n    padding: 20px;\r\n    border: 1px solid #e7e7e7;\r\n    border-top: none;\r\n    border-radius: 0 0 5px 5px;\r\n    background-color: #ffffff;\r\n    margin-bottom: 20px;\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
